import script from "./ConsoleSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsoleSettings.vue?vue&type=script&setup=true&lang=js"

import "./ConsoleSettings.vue?vue&type=style&index=0&id=183a389e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-183a389e"]])

export default __exports__